import React from 'react'

import { Chevron } from '../Chevron'

interface AccordionItemProps {
  title: React.ReactNode
  children: React.ReactNode
}

export const AccordionItem = ({ title, children }: AccordionItemProps) => {
  const [isOpen, setIsOpen] = React.useState(false)

  const handleToggle = () => {
    setIsOpen(prev => !prev)
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        borderBottom: '1px solid #e2e8f0',
        padding: '16px 0',
      }}
    >
      <div
        style={{
          color: '#5C6F8A',
          cursor: 'pointer',
          padding: '8px 0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
        onClick={handleToggle}
      >
        <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          {typeof title === 'string' ? title.toLocaleUpperCase() : title}
        </span>
        <Chevron direction={isOpen ? 'up' : 'down'} />
      </div>
      {isOpen && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            fontSize: '16px',
            lineHeight: '24px',
          }}
        >
          {children}
        </div>
      )}
    </div>
  )
}
